"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JudgeLocalizedReferenceSchema = void 0;
exports.JudgeLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/judges.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "JudgeLocalizedReference",
    "description": "A person who is part of a judging panel, consisting of renowned experts that are voting in Red Bull competitions - e.g. Red Bull Illume judges.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:judges"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianVkZ2VzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC9qdWRnZXMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsS0FBSyxFQUFFLGdGQUFnRjtJQUN2RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx5QkFBeUI7SUFDbEMsYUFBYSxFQUFFLGlKQUFpSjtJQUNoSyxNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLG9CQUFvQjthQUNyQjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLGlHQUFpRztTQUM3RztLQUNGO0NBQ0YsQ0FBQSJ9